module.exports = __webpack_public_path__ + "static/media/bgm.223b63cf.mp3";